// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7dde2739","488":"88349730","977":"3f6b54a1"}[chunkId] + ".chunk.js";
};